import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { FuncionarioColumns } from './columns/_columns'
import { FuncionarioList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const FuncionariosTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { selected } = useListView()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const columns = useMemo(() => FuncionarioColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={
        filters.nome
          ? `Nenhum funcionário encontrado para “${filters.nome}”`
          : 'Nenhum funcionário com esses filtros'
      }
      description='Revise o nome digitado ou os filtros selecionados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum funcionário cadastrado'
      description='Use “Adicionar” para localizar e vincular o primeiro funcionário.'
    />
  )

  return (
    <CustomTable<FuncionarioList>
      id='kt_table_funcionarios'
      ariaLabel='Funcionários'
      itemLabel={{ singular: 'funcionário', plural: 'funcionários' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => !!row.id && selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
